import React, { useState, useEffect } from "react";
import ApiCaller from "../../../../api/apiCaller";
import {
  Col,
  Row,
  Container,
  Table,
  FormGroup,
  Button,
  Input,
} from "reactstrap";
import UserModal from "../../components/UserModal";
import ImportModal from "../../components/ImportModal";
import "./index.css";
import t from "utils/Lang";

// The Roster component matches one of two different routes
// depending on the full pathname

const Users = () => {
  const [users, setUsers] = useState([]);
  const [searchKeywords, setSearchKeywords] = useState<string>("");
  const [isSearching, setIsSearching] = useState<boolean>(false);
  const [selectedUser, setSelectedUser] = useState<any | null>(null);
  const [showUserModal, setShowUserModal] = useState<boolean>(false);
  const [showImportModal, setShowImportModal] = useState<boolean>(false);
  const getUsers = async () => {
    setUsers([]);
    let uri = `user/current_brand?get_all_status=1&get_zones=1`;
    if (searchKeywords) {
      uri = `${uri}&q=${searchKeywords}`;
    }
    const res = await ApiCaller.get(uri);
    if (res.result) {
      setUsers(res.result);
      setIsSearching(false);
    }
  };
  const toggleUserModal = (isCreate: boolean) => {
    setShowUserModal(!showUserModal);
    if (isCreate) {
      setSelectedUser(null);
    }
  };
  const toggleImportModal = () => {
    setShowImportModal(!showImportModal);
  };
  const onUserSelected = (user: any) => {
    setSelectedUser(user);
    setShowUserModal(true);
  };
  const onSearchButtonClick = () => {
    setIsSearching(true);
    getUsers();
  };
  const onSearchEnterPressed = (e: any) => {
    if (e.key === "Enter") {
      onSearchButtonClick();
    }
  };
  useEffect(() => {
    getUsers();
  }, []);
  useEffect(() => {
    // Reload all list
    if (!searchKeywords) {
      getUsers();
    }
  }, [searchKeywords]);
  return (
    <Container>
      <Row>
        <Col xs={12}>
          <h1>{t().settings__user_management}</h1>
        </Col>
      </Row>
      <Row>
        <Col xs={12} sm={6}>
          <FormGroup>
            <Input
              type="text"
              placeholder={t().setting_user__search_placeholder}
              onChange={(e) => setSearchKeywords(e.target.value)}
              onKeyDown={(e) => onSearchEnterPressed(e)}
            />
          </FormGroup>
        </Col>
        <Col xs={12} sm={2}>
          <FormGroup>
            <Button
              color={searchKeywords ? "primary" : "secondary"}
              onClick={onSearchButtonClick}
              disabled={isSearching}
            >
              <i className="material-icons">search</i>
              <span>
                {isSearching
                  ? t().setting_user__searching
                  : t().setting_user__search}
              </span>
            </Button>
          </FormGroup>
        </Col>
        <Col xs={12} sm={2}>
          <FormGroup>
            <Button color="primary" onClick={() => toggleUserModal(false)}>
              <i className="material-icons">add</i>
              <span>{t().setting_user__create_user}</span>
            </Button>
          </FormGroup>
        </Col>
        <Col xs={12} sm={2}>
          <FormGroup>
            <Button color="primary" onClick={() => toggleImportModal()}>
              <i className="material-icons">publish</i>
              <span>{t().setting_user__import_user}</span>
            </Button>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <Table striped>
            <thead>
              <th>ID</th>
              <th>Username</th>
              <th>Full name</th>
              <th>Active</th>
              <th>Roles</th>
            </thead>
            <tbody>
              {users.map((user: any) => (
                <tr
                  key={`${user.id}`}
                  onClick={() => onUserSelected(user)}
                  className={`${
                    !user.is_active && "user-listing__users__inactive"
                  }`}
                >
                  <td>{user.id}</td>
                  <td>{user.username}</td>
                  <td>{`${user.first_name} ${user.last_name}`}</td>
                  <td>{`${user.is_active}`}</td>
                  <td>
                    {user.roles.map((role: any, index) => (
                      <span className="user-listing__role" key={index}>{role.name}</span>
                    ))}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Col>
      </Row>
      {showUserModal && (
        <UserModal
          isShow={showUserModal}
          onModalToggle={toggleUserModal}
          selectedUser={selectedUser}
          onUserSaved={getUsers}
        />
      )}
      {showImportModal && (
        <ImportModal
          isShow={showImportModal}
          onModalToggle={toggleImportModal}
          onCompleted={getUsers}
        />
      )}
    </Container>
  );
};

export default Users;
